import { useIntersection } from '@hooks/useIntersection';

import { useState } from 'react';

export const useIsIntersecting = (parent?: HTMLElement | null) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const { refCallback } = useIntersection({
        onIntersection: () => setIsIntersecting(true),
        onLeave: () => setIsIntersecting(false),
    });

    return { refCallback, isIntersecting };
};
